import * as React from "react";
import { Modal, Button, Col, Row, Input } from "antd";
import { TDevicePresentationModel } from "../../../presenter/device/model/DevicePresentationModel";
import RemoveDeviceForm from "./RemoveDeviceForm";
import Text from "antd/lib/typography/Text";
import TextArea from "antd/lib/input/TextArea";
import { CheckOutlined, StopOutlined } from "@ant-design/icons";

const ConfirmationModal = ({
  translate,
  onConfirm,
  onCancel,
  modalVisible,
  selectedDevice,
  loading,
  username,
  password,
  onChangeUsername,
  onChangePassword,
  loginButtonDisabled
}: {
  translate: any;
  onCancel: any;
  onConfirm: any;
  modalVisible: boolean;
  selectedDevice?: TDevicePresentationModel;
  loading: boolean;
  username: string;
  password: string;
  onChangeUsername: any;
  onChangePassword: any;
  loginButtonDisabled: boolean;
}) => {
  const handleSubmit = () => {
    onConfirm(selectedDevice?.id);
  };

  return (
    <React.Fragment>
      <Modal
        title={translate("device_management_page.modal_title")}
        centered
        open={modalVisible}
        onCancel={onCancel}
        confirmLoading={true}
        footer={[
          <Button
            className="button-secondary"
            key="cancel"
            icon={<StopOutlined />}
            onClick={onCancel}
          >
            {translate("device_management_page.modal_cancel")}
          </Button>,
          <Button
            className="button-primary"
            key="submit"
            icon={<CheckOutlined />}
            onClick={handleSubmit}
            loading={loading}
            disabled={loginButtonDisabled}
          >
            {translate("device_management_page.modal_ok")}
          </Button>
        ]}
      >
        <Row gutter={[8, 8]}>
          <Col lg={10} xs={24}>
            <Row className={"group-items"}>
              <Text className={"label"}>
                {translate("device_management_page.registration_date")}
              </Text>
              <Input
                readOnly
                className={"input"}
                value={selectedDevice?.registrationDate}
              />
            </Row>
            <Row className={"group-items"}>
              <Text className={"label"}>
                {translate("device_management_page.description")}
              </Text>
              <TextArea
                readOnly
                className={"input"}
                value={selectedDevice?.description}
              />
            </Row>
          </Col>

          <Col lg={14} xs={24}>
            <div className={"content-section-emphasize"}>
              <RemoveDeviceForm
                translate={translate}
                username={username}
                password={password}
                onChangeUsername={onChangeUsername}
                onChangePassword={onChangePassword}
                handleEnterPress={handleSubmit}
              />
            </div>
          </Col>
        </Row>
      </Modal>
    </React.Fragment>
  );
};

export default ConfirmationModal;
